const disc = {
	description: "Team members tend to be thoughtful, engaging, and practical personalities who seek certainty and stability. The team may follow set plans and appreciate working with specific information. The team is well designed to solve problems together. Team members may have difficulty boldly stating opinions or quickly making decisions.",
	strengths: [
		"Keeping track of details and checking in on work progress",
		"Considering possible outcomes and potential setbacks before making a decision",
		"Thoughtfully helping each other work through problems and bringing different approaches to the table",
		"Making stable, trustworthy choices",
		"Maintaining a balance between data-driven and intuitive decisions",
	],
	blindSpots: [
		"Difficulty working at an intense and fast pace; some individuals will want more time to think through work than others",
		"Some members may keep too many thoughts to themselves",
		"May struggle to find balance between the team’s social relationship and work efficiency",
		"Tendency to get stuck doing things one way, without trying something new",
		"May overlook good creative ideas in order to be more precise or accurate",
	],
};

const dis = {
	description: "This team consists of mostly innovative people who prefer to talk through solutions, value creativity, open communication, and inventiveness. Team members’ friendliness help to create a great problem-solving culture that fosters new ideas; however, the group may move too fast without enough follow through.",
	strengths: [
		"Communicating openly, always working to understand the perspectives of others",
		"Use flexible schedules and open-ended approaches to time management",
		"Value big picture thinking and constantly find important opportunities to pursue",
		"Trust intuition and ability to improvise; making bold decisions with limited information",
		"Motivate each other with verbal encouragement while working in a high energy environment",

	],
	blindSpots: [
		"May get distracted from too much socializing",
		"May struggle to do research and assemble information; uncomfortable dealing with heavy data",
		"May be unrealistically optimistic when assessing problems",
		"May struggle to offer direct feedback or be blunt when necessary",
		"May struggle to create clear and concise plans that ensure team progress; some team members will find it hard work through all the necessary details of a goal",
	],
};

const dic = {
	description: "This team is filled with competitive personalities motivated by achievement and continual progress. Team members will likely pursue goals methodically and reward consistent, high-quality results. This regimented workflow might discourage the creative, innovative members from pushing the group to try new ideas.",
	strengths: [
		"Directly communicating their opinions and having frequent conversations regarding work progress",
		"Consistently improving their efficiency by iterating team procedures",
		"Bringing underlying conflict to the surface; this team values transparency and directness",
		"Regularly challenging one another to get better and working to achieve high results",
		"Accomplishing important goals and remaining on task",
	],
	blindSpots: [
		"Some team members may offend others with blunt feedback; those who are less direct may feel unheard or uncomfortable",
		"Team may seek efficiency over empathy or personal connection",
		"May struggle to remain patient when stressed",
		"May avoid big picture thinking or brainstorming due to uncertainty and risk",
	],
};

const dsc = {
	description: "This team is predominantly made up of focused, objective thinkers. The group tends to be good at thoroughly considering decisions, testing solutions, and asking important questions. Some team members have a tendency to work independently to work more efficiently or follow specific processes and it may be difficult or draining for more extroverted, imaginative people within the group.",
	strengths: [
		"Team members are both trustworthy and reliable with work production; holding each other accountable to complete tasks",
		"Avoiding emotion-driven decisions; value procedures and accuracy",
		"Sticking to deadlines and maintaining quality by remembering important details",
		"Thoughtfully helping each other work through problems",
		"Operating with a sense of urgency, consistently improving efficiency and accomplishing goals with definitive results",
	],
	blindSpots: [
		"May struggle with brainstorming or using open ended approaches to difficult problems",
		"Can be overly critical of one another or have difficulty openly communicating; may lack verbal encouragement and team motivation",
		"Difficulty maintaining a consistently high level of enthusiasm",
		"Team members may struggle to find balance between working independently and as a group",
	],
};

const isc = {
	description: "As most people in this team tend to be consistent and even-tempered, the group is likely gifted at maintaining a harmonious, peaceful environment.They are skilled at identifying flawed thoughts and finding the most effective solutions for a given problem. They may, however, have a difficult time making firm decisions, since many of them tend to be very accommodating.",
	strengths: [
		"Places a high priority on personal relationships, good at open and empathetic discussion",
		"Making stable, trustworthy choices and thinking through potential repercussions",
		"Creates defined procedures for team processes",
		"Resolving conflict without escalating it",
		"Create and execute organized plans",
	],
	blindSpots: [
		"Team members may struggle to find balance between working independently and as a group",
		"The group may struggle with making quick, firm decisions and understanding each others’ point of view",
		"May struggle to take action toward making changes",
		"Minimizing negative feedback, leaving others unclear about the problem",
		"Difficulty working quickly under pressure and completing work individually",
	],
};

const di = {
	description: "This team is likely to value achievement and quick-thinking over detailed and accurate solutions. Team members can be confident and vocal. Some will prioritize logic, while others value open discussion and communication. The team tends to be clear and to-the-point, but bolder voices may overshadow more emotive or reserved ones. Team members will need to work to find a balance between creativity and clear direction.",
	strengths: [
		"Pursuing goals with confidence, efficiency, and accountability",
		"Value big picture thinking and constantly find important opportunities to pursue",
		"Trust intuition and ability to improvise; making bold decisions with limited information",
		"Motivating and exciting one another; maintaining a high level of energy",
		"Uses flexible schedules and open-ended approaches to time management",
	],
	blindSpots: [
		"Team may have a hard time following routine; impatience may arise when detailed instructions are presented",
		"May rush into making a decision before weighing its impact",
		"Team members may be susceptible to talking over one another or getting sidetracked in meetings",
		"May have difficulty making well-coordinated plans; individuals are highly enthusiastic and do not take time to outline tasks",
		"May fail to evaluate problems realistically due to optimistic expectations of people/situations or overlooking important data",
	],
};

const ds = {
	description: "This team will have a mixture of values, some who seek harmony and others who value being direct and independent. With many natural collaborators in the team, the culture will likely be friendly and positive, with most team members making an effort to make others feel welcome and heard. However, the group might lack internal pressure to meet deadlines and deal with conflict directly.",
	strengths: [
		"Enthusiastic about setting goals and persistent in reaching them even when obstacles arise",
		"Ability to flex more cautious and thoughtful consideration in some situations while utilizing more urgent, demanding attributes in times of pressure",
		"Team members are both trustworthy and reliable with work production; holding each other accountable to complete tasks",
		"Operate with a sense of urgency, consistently improving their efficiency",
		"Remaining patient in tense situations and resolving conflict without escalation",
	],
	blindSpots: [
		"Team may make too many emotional decisions or rely on intuitive thinking",
		"May neglect to follow strict procedures or have conversations about team norms",
		"May neglect work efficiency for the sake of team socializing",
		"Team members may struggle with ambitious goals and making firm decisions",
		"May lack complementary and consistent forms of motivation, communication, and conflict resolution",
	],
};

const dc = {
	description: "Most of the personalities in this team tend to be naturally skeptical, outspoken, and results-driven. Team members are likely to be skilled at identifying flawed thoughts and finding the most effective solutions for a given problem. While they tend to be productive, effective team members can be overly harsh or critical at times.",
	strengths: [
		"Identifying significant flaws in a process or idea and detecting potential setbacks",
		"Avoiding irrational, emotion-driven decisions; values procedures and accuracy",
		"Sticking to deadlines and maintaining quality by remembering important details",
		"Asking important pointed questions",
		"Operating with a sense of urgency, consistently improving efficiency and accomplishing goals with definitive results",
	],
	blindSpots: [
		"May have trouble seeing things from another perspective and understanding the emotional impact of decisions",
		"Team may avoid big picture thinking or brainstorming due to uncertainty and risk",
		"Interpersonal relationships may suffer due to prioritization of work efficiency and productivity",
		"Team members may display impatience when provided with detailed instruction",
		"Not placing an emphasis on welcoming or including others; Tendency to maintain a strict, blunt environment",
	],
};

const is = {
	description: "This team is likely to value structure and routine, and is largely made up of people who are respectful and supportive. They form strong relationships and an underlying sense of trust, but may have a tendency to shy away from conflict, which can slow progress when difficult situations arise.",
	strengths: [
		"Keeping a friendly, inviting culture and always offering help to fellow members",
		"Places a high priority on personal relationships, creates open and empathetic discussion to make sure everyone feels comfortable",
		"Use flexible schedules and open-ended approaches to time management.",
		"Value big picture thinking and constantly find important opportunities to pursue",
		"Create and execute organized plans; considering the impact on the stability of the group when making changes.",
	],
	blindSpots: [
		"May have a hard time offering direct feedback or being blunt when necessary",
		"The team may struggle to enforce rules or define clear roles",
		"May have difficulty working quickly under pressure and completing work individually",
		"Team members may have difficulty taking action to change",
		"The team may struggle to research and assemble information; uncomfortable dealing with heavy data",
	],
};

const ic = {
	description: "This team is likely to have a mixture of personalities that value stability, cooperation and demand that any decision is backed up by data and logic. Though many of the members' thorough research may lead the group to experience very few failures, any team members that are more creative, enthusiastic, or instinctual might feel trapped or frustrated by over-analysis and detail-oriented questions.",
	strengths: [
		"Offering insightful observations and feedback",
		"Having a blend of realistically assessing problems and optimistic thinking",
		"Utilizing data-backed solutions even in creative work",
		"Making stable, trustworthy choices and thinking through potential repercussions",
		"Remembering important details and having a set plan",
	],
	blindSpots: [
		"May struggle with making quick, firm decisions and understanding each others’ point of view",
		"Trouble brainstorming new ideas as some prefer to follow set processes",
		"Can be overly critical of one another and not take the time to create valuable team relationships",
		"Miscommunication about each others’ needs regarding group vs independent work",
		"May lack complementary and consistent forms of motivation and communication, and conflict resolution",
	],
};

const sc = {
	description: "This team is full of more reserved, diplomatic personalities that place a high value on trust, sincerity, and predictability. Team members may establish structures and routines to create a stable work environment, which may feel restrictive to other members that operate more on instinct.",
	strengths: [
		"Considering possible outcomes before making a decision and working through all potential setbacks",
		"Making stable, trustworthy choices",
		"Keeping track of details and relying on data-driven results",
		"Creating defined procedures for team processes",
		"Thoughtfully helping each other work through problems",
	],
	blindSpots: [
		"Keeping too many thoughts to themselves, neglecting to share with each other",
		"Tendency to be fearful of creative ideas or trying new procedures",
		"Difficulty working at an intense and fast pace, always looking for a perfect solution rather than accepting a working solution",
		"May have a tendency to minimize negative feedback, leaving others unclear about the problem",
		"Team members may struggle to find balance between working independently and as a group",
	],
};

const d = {
	description: "Most of the personalities in this team are naturally assertive and competitive. They are motivated by challenge and enthusiastic about setting goals. Team members are likely to value results more than process and may have difficulty taking the time to completely consider all options before making a decision.",
	strengths: [
		"Directly communicating opinions and holding one another accountable for following through",
		"Operates with a sense of urgency, consistently improving their efficiency",
		"Comfortable with responsibility and ownership over results",
		"Uses a goal-oriented approach to assigning work, omitting unnecessary details",
		"Quick, independent, and firm when making decisions; many individuals on this team are natural leaders",
	],
	blindSpots: [
		"Team members may seem aggressive or direct when resolving conflict, they may offend others with blunt feedback",
		"Goal-oriented approach to assigning work sometimes results in omitting necessary details or failure to take a step back and realign work",
		"May seek efficiency over empathy or personal connection",
		"May prioritize independence, failing to involve others in problem-solving due to desire for an immediate solution",
		"Team may have trouble being patient",
	],
};

const i = {
	description: "With mostly innovative people who prefer to talk through solutions, this team tends to value creativity and inventiveness. This may be a great problem-solving culture that constantly contributes new ideas; however, the team may also move too fast without enough follow through.",
	strengths: [
		"Solves problems by involving others in brainstorming and open discussion.",
		"Places a high priority on personal interactions and relationships, always remaining optimistic and enthusiastic",
		"Motivate each other with verbal encouragement while working in a high energy environment",
		"Value big picture thinking and constantly find important opportunities to pursue",
		"Uses flexible schedules and open-ended approaches to time management.",
	],
	blindSpots: [
		"Can spend more time interacting with people than on completing tasks",
		"May pursue too many new ideas or opportunities at once, susceptible to running behind or forgetting certain deadlines",
		"Team may fail to evaluate problems realistically due to optimistic expectations of people/situations.",
		"May have difficulty researching and assembling information; uncomfortable dealing with heavy data",
		"The team may have trouble following consistent, predictable routines.",
	],
};

const s = {
	description: "This team is mostly made up of considerate, patient listeners, who tend to be good at helping others feel heard and welcome. Team members are both trustworthy and reliable with work production. Because many of them tend to avoid conflict, they may run into problems with unresolved tension.",
	strengths: [
		"Remaining patient in tense situations and resolving conflict without escalation",
		"Very attentive to the needs and concerns of other people",
		"Supportive, encouraging, and trusting of teammates’ abilities",
		"Check in with team on a regular basis and consistently offer help",
		"Creating and executing organized plans; considers the impact on the stability of the group when making changes.",
	],
	blindSpots: [
		"Trouble directly addressing unspoken tensions and communicating with seemingly aggressive people",
		"Uncomfortable with independent responsibility and ownership over results",
		"The team may have a hard time going all in on an ambitious goal and making firm decisions",
		"May minimize negative feedback, leaving others unclear about the problem",
		"Team members may not be forceful or assertive when necessary",
	],
};

const c = {
	description: "This team is predominantly made up of focused, objective thinkers. Team members tend to be good at thoroughly considering decisions, testing solutions, and asking important questions. The tendency for them to work independently and follow specific processes may be difficult or draining for more creative, imaginative people.",
	strengths: [
		"Taking time to gather information and analyze the impact before making a decision",
		"Uses a deliberate, logical, and methodical approach when solving problems.",
		"Comfortable analyzing large amounts of information",
		"Emphasis on tested and data-backed solutions",
		"Maintains quality by asking questions frequently, remembering important details and working efficiently",
	],
	blindSpots: [
		"Can be overly critical of one another, especially when standards for quality and accuracy are not met",
		"Interpersonal relationships may suffer due to prioritization of work efficiency and productivity",
		"May seek a perfect solution instead of a workable solution",
		"Overcomplicates solutions to simple problems; may spend too much time gathering information and assessing risk before making decisions",
		"May need a lot more time to build trust with each other",
	],
};

export default {
	disc,
	dis,
	dic,
	dsc,
	isc,
	di,
	ds,
	dc,
	is,
	ic,
	sc,
	d,
	i,
	s,
	c,
};



// WEBPACK FOOTER //
// ./src/components/Team/teamWorkStyles.js